import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PostContent from 'components/Presentation/PostContent';
import { Spinner } from 'UI';
import MyPlanning from 'containers/Overview/Sections/MyPlans';
import MyPosts from 'containers/Overview/Sections/MyPosts';
import { getDescription } from 'helpers/content';
var PreSchoolSection = /*#__PURE__*/function (_Component) {
  function PreSchoolSection(props) {
    var _this;
    _classCallCheck(this, PreSchoolSection);
    _this = _callSuper(this, PreSchoolSection, [props]);
    _defineProperty(_this, "renderGroupContent", function () {
      var group = _this.props.group;
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section left-side"
      }, group.description ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PostContent, null, getDescription(group.description))) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }), _this.props.activeStudent != null && _this.props.activeStudent.services.news ? /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(MyPosts, {
        overview: true,
        limit: 3,
        groupid: group.id
      })) : null, _this.props.activeStudent != null && _this.props.activeStudent.services.plans ? /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(MyPlanning, {
        overview: true,
        groupid: group.id,
        dateRestriction: false
      })) : null);
    });
    return _this;
  }
  _inherits(PreSchoolSection, _Component);
  return _createClass(PreSchoolSection, [{
    key: "render",
    value: function render() {
      var group = this.props.group;
      if (!group) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
      return /*#__PURE__*/React.createElement("div", null, this.renderGroupContent());
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    group: state.groups.activeGroup,
    activeStudent: state.User.activeStudent
  };
};
export default connect(mapStateToProps)(PreSchoolSection);